import { icon } from "../../../common/js/icon";

const sliderRootSelector = '.glide';
const sliderGroupSelector = '.glide__slides';

/**
 * The names of the arrows, from the language of the page (MediaLoader writes them into
 * window.EventGalleryLightboxConfiguration); until 7.0.0 the arrows read "prev" and "next" in
 * every language.
 *
 * @returns {{previous: string, next: string}}
 */
function arrowNames() {
    const texts = typeof window !== 'undefined' ? window.EventGalleryLightboxConfiguration : null;
    return {
        previous: (texts && texts.KEY_SLIDER_PREVIOUS) || 'Previous images',
        next: (texts && texts.KEY_SLIDER_NEXT) || 'Next images',
    };
}

/**
 * The markup of Glide around the slides: the track and two buttons of the design system
 * (eg-btn) with a chevron which a right-to-left page mirrors and a name for a screen reader. The
 * classes glide__arrow and the data-glide-dir of Glide stay.
 *
 * @returns {string}
 */
function basicMarkup() {
    const names = arrowNames();
    const escape = (value) => String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
    return `
<div class="glide">
    <div class="glide__track" data-glide-el="track">
        <ul class="glide__slides">
        </ul>
    </div>
    <div class="glide__arrows" data-glide-el="controls">
        <button type="button" class="glide__arrow glide__arrow--left eg-btn eg-btn--secondary eg-btn--icon" data-glide-dir="<" aria-label="${escape(names.previous)}">${icon('chevron-left', 'eg-icon--rtl-flip')}</button>
        <button type="button" class="glide__arrow glide__arrow--right eg-btn eg-btn--secondary eg-btn--icon" data-glide-dir=">" aria-label="${escape(names.next)}">${icon('chevron-right', 'eg-icon--rtl-flip')}</button>
    </div>
</div>`;
}

export default class SliderTransformator {

    constructor(sourceGroupElement, sourceElementSelector) {
        this.elementSelector = sourceElementSelector;
        this.sourceGroupElement = sourceGroupElement;
        this.sourceElements = this.getSourceElements();
    }

    getSourceElements() {
        if (this.sourceGroupElement === null) {
            return null;
        }
        return this.sourceGroupElement.querySelectorAll(this.elementSelector);
    }

    transform(numberOfItemsPerSlide) {
        if (this.sourceGroupElement === null || this.sourceElements === null) {
            return null;
        }

        if (this.sourceElements.length === 0) {
            return null;
        }
        // cleanup
        let sliderRoot = this.sourceGroupElement.querySelector(sliderRootSelector);

        if (sliderRoot !== null) {
            sliderRoot.remove();
        }
        // transformation

        let sliderMarkup = document.createRange().createContextualFragment(basicMarkup());
        // a slider of more than one slide has its arrows, the only way for the keyboard and a
        // screen reader into the slides out of view, which are inert (markSlidesOutOfView()); until
        // the review of #1894 the option "Show the arrows" could leave them out - the default of
        // the content plugin -, and nothing but a swipe or the autoplay reached those slides
        if (this.sourceElements.length <= numberOfItemsPerSlide) {
            sliderMarkup.querySelector('.glide__arrows').remove();
        }
        let sliderGroupElement = sliderMarkup.querySelector(sliderGroupSelector);
        let currentSliderElement = null;

        for(let index=0; index<this.sourceElements.length; index++) {
            let element = this.sourceElements[index];
            if (index % numberOfItemsPerSlide === 0) {
                currentSliderElement = document.createElement('li');
                currentSliderElement.className = 'glide__slide';
                sliderGroupElement.appendChild(currentSliderElement);
            }
            currentSliderElement.appendChild(element);
        }

        this.sourceGroupElement.appendChild(sliderMarkup);

        return this.sourceGroupElement.querySelector(sliderRootSelector);

    }

}
